import { useDroppable } from '@dnd-kit/core';
import { useRef, useMemo } from 'react';
import { units } from '@ui/css';
import { inTextDropzoneInput } from '@utils/component-framework';
import { useOpgavekompleksetComponent } from '../../../../../state/context.data.js';
import { useOpgavekompleksetEntry } from '../../../../../state/hook.entry.js';
import { useTaskContext } from '../../../context.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../../hook.task-breakpoints.js';
import { DraggableTile } from '../atom.draggable.js';
import { PlaceItemsInTextTile } from '../atom.tile.js';
import { tokens, wrapper, drawer, label } from './_drawer.style.js';
import { DragHandle } from './atom.drag-handle.js';
import { useIsSticky } from './hook.is-sticky.js';
import { useStickyOffsetHandlers } from './hook.sticky-offset.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function TileDrawer(props) {
  const component = useOpgavekompleksetComponent();
  const ref = useRef(null);
  const {
    setNodeRef
  } = useDroppable({
    id: "drawer",
    disabled: !props.draggable
  });
  const context = useTaskContext();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => Object.values(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(value => inTextDropzoneInput.entry.asTypeSafe(value)).filter(it => !!it)
  });
  const sortedTiles = useMemo(() => {
    if (context !== "input") {
      return props.tiles;
    }
    return [...props.tiles].sort((a, b) => {
      const isAPlaced = inputEntry?.some(it => it.tileId === a.id);
      const isBPlaced = inputEntry?.some(it => it.tileId === b.id);
      if (isAPlaced) {
        return 1;
      }
      if (isBPlaced) {
        return -1;
      }
      return 0;
    });
  }, [context, inputEntry, props.tiles]);
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const isSticky = useIsSticky(ref, [isMobile]);
  const {
    canChangeOffset,
    stickyOffset,
    updateOffset
  } = useStickyOffsetHandlers(ref, component.data.settings.standalone.audience);
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: wrapper,
    "data-sticky": isSticky,
    style: tokens.stickyOffset.__override(units.px(stickyOffset)),
    children: [/*#__PURE__*/jsx(DragHandle, {
      visible: isSticky && canChangeOffset,
      yPosition: stickyOffset,
      updatePosition: updateOffset
    }), /*#__PURE__*/jsxs("div", {
      className: drawer,
      "data-type": props.type,
      ref: setNodeRef,
      children: [/*#__PURE__*/jsxs("span", {
        className: label,
        children: [props.tiles.length, " brik", props.tiles.length !== 1 ? "ker" : ""]
      }), sortedTiles.map(tile => props.draggable ? /*#__PURE__*/jsx(DraggableTile, {
        tile: tile,
        context: "drawer",
        state: "input",
        taskEntryKey: props.taskEntryKey,
        isDraggingItem: tile.id === props.draggedTileId
      }, tile.id) : /*#__PURE__*/jsx(PlaceItemsInTextTile, {
        taskEntryKey: props.taskEntryKey,
        context: "drawer",
        state: "placed",
        tile: tile
      }, tile.id))]
    })]
  });
}

export { TileDrawer };
//# sourceMappingURL=_drawer.js.map
